import { useMemo } from 'react';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from '@tanstack/react-table';

import { LoadingWarren } from '@simplywallst/ui-core';

import { getTableOverviewColumns } from '../TableOverview/utils';

export const LoadingState = ({ currencyISO }: { currencyISO: string }) => {
  const columns = useMemo(
    () => getTableOverviewColumns(currencyISO),
    [currencyISO]
  );
  const table = useReactTable({
    getCoreRowModel: getCoreRowModel(),
    columns,
    data: [],
  });
  return (
    <div className="relative h-dvh w-full overflow-hidden bg-p-white-100">
      <table
        aria-label="Loading"
        className="w-full border-separate border-spacing-0"
      >
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr
              key={`table-overview-${headerGroup.id}`}
              aria-label="Overview Header"
            >
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className="border-b border-l-0 border-r border-t-0 border-solid border-soft bg-surface-2 p-x2 py-x1_5 text-right align-bottom text-tiny font-strong leading-tight text-soft first:text-left"
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
      </table>
      <div className="absolute left-0 top-0 grid size-full items-start justify-center bg-[rgba(0,0,0,.5)] pt-x16">
        <LoadingWarren />
      </div>
    </div>
  );
};
